import React, { Component, Fragment } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import propTypes from "prop-types";
import "bootstrap";
import { confirmAlert } from "react-confirm-alert";
import "./overlay.css";
// import moment from "moment";

import Notification from "../components/UI/ToastNotification/ToastNotification";
import {
  List,
  ListItem,
  Paper,
  Stack,
  ListItemText,
  Typography,
  Button,
} from "@mui/material";

const errorHandler = (WrappedComponent, axios) => {
  return class extends Component {
    state = {
      error: null,
      type: null,
      mannualDismissal: false,
    };

    UNSAFE_componentWillMount() {
      this.requestInterceptor = axios.interceptors.request.use((request) => {
        const requestUrlCopy = request.url;
        const urlArray = requestUrlCopy.split("/");
        const lastPartOfUrl = urlArray.pop();
        const urlWithoutLastInput = urlArray.join("/");
        if (
          request.method !== "get" &&
          !(
            urlWithoutLastInput === "/meetings/agenda/files" ||
            urlWithoutLastInput === "/meetings/agenda/resource_files" ||
            request.url === "/approvals/comment" ||
            request.url?.toLowerCase().includes("risks") ||
            lastPartOfUrl === "attendance" ||
            lastPartOfUrl === "update_agenda" ||
            request.url === "/approvals/comment/reply" ||
            request.url === "/meeting/action_item" ||
            request.url === "/meeting/action_item/delete" ||
            urlArray.join("/") === "/meetings/invitation" ||
            (request.method === "put" && lastPartOfUrl === "minutes")
          )
        ) {
          this.props.onLoading();
        }
        return request;
      });

      this.responseInterceptor = axios.interceptors.response.use(
        (response) => {
          if (response) {
            if (response.config.method !== "get") {
              window.$(".dismissible").modal("hide");
              window.$(".modal-backdrop").remove();
            }
            if (this.props.loading && this.props.isUpdated)
              this.props.onLoaded();
            return response;
          }
        },
        (error) => {
          let message;
          let errorType;

          if (error.response) {
            message = error.response.data.message;
            errorType = "info";

            if (
              error.response.status === 403 &&
              error.response.data.message.includes(
                "Maximum Devices Logged In reached"
              )
            ) {
              window.$("#tokenExpiryModal").modal("show");
            }
            if (
              error.response.status === 403 &&
              error.response.data.message.includes("Password expired")
            ) {
              // window.$("#expiredPasswordModal").modal("show");
              window.location.assign(
                `${process.env.REACT_APP_HOMEPAGE}/expired-password`
              );
            } else if (
              error.response.status === 403 &&
              error.response.data.message.includes("Password expired")
            ) {
              this.props.signOut();
            }

            if (
              error.response.status === 403 &&
              error.response.data.message.includes(
                "Another device has logged in as you"
              ) &&
              this.props.auth.tokenIsValid
            ) {
              this.props.setOtherLoggedInUser(error.response.data.other_user);
              this.props.resetGroups();
              this.props.resetUsers();
              this.props.resetNonUsers();
              this.props.resetResources();
              this.props.resetApprovals();
              this.props.setTokenIsInValid();
              confirmAlert({
                customUI: ({ onClose }) => {
                  return (
                    <Paper
                      sx={{
                        minHeight: 500,
                        maxWidth: 500,
                        borderRadius: 5,
                        padding: 5,
                      }}
                      elevation={8}
                    >
                      <Stack direction="column" spacing={2}>
                        <Typography sx={{ fontFamily: "inherit" }} variant="h3">
                          {this.props.auth.otherLoggedInUser
                            ? this.props.auth.otherLoggedInUser.same_network
                              ? "A DEVICE ON THIS NETWORK IS LOGGED IN AS YOU"
                              : "A DEVICE ON A DIFFERENT NETWORK IS LOGGED IN AS YOU"
                            : "An New Device has Logged In as you"}
                        </Typography>
                        <Typography sx={{ fontFamily: "inherit" }} variant="h6">
                          Details
                        </Typography>
                        {this.props.auth.otherLoggedInUser &&
                        this.props.auth.otherLoggedInUser.device ? (
                          this.props.auth.otherLoggedInUser.device?.platform.includes(
                            "iOS"
                          ) ? (
                            <List dense>
                              <ListItem>
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontSize: 15,
                                    fontWeight: "medium",
                                    lineHeight: "20px",
                                    mb: "2px",
                                  }}
                                >
                                  Device: IPAD
                                </ListItemText>
                              </ListItem>
                              <ListItem>
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontSize: 15,
                                    fontWeight: "medium",
                                    lineHeight: "20px",
                                    mb: "2px",
                                  }}
                                >
                                  Platform: IOS
                                </ListItemText>
                              </ListItem>
                              <ListItem>
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontSize: 15,
                                    fontWeight: "medium",
                                    lineHeight: "20px",
                                    mb: "2px",
                                  }}
                                >
                                  Time:{" "}
                                  {this.props.auth.otherLoggedInUser.time &&
                                  this.props.auth.otherLoggedInUser.time_diff
                                    ? `${this.props.auth.otherLoggedInUser.time_diff} (${this.props.auth.otherLoggedInUser.time})`
                                    : "Unknown"}
                                </ListItemText>
                              </ListItem>
                            </List>
                          ) : (
                            <List dense>
                              <ListItem>
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontSize: 15,
                                    fontWeight: "medium",
                                    lineHeight: "20px",
                                    mb: "2px",
                                  }}
                                >
                                  Browser:{" "}
                                  {this.props.auth.otherLoggedInUser.device
                                    .browser
                                    ? this.props.auth.otherLoggedInUser.device
                                        .browser
                                    : "Unknown"}
                                </ListItemText>
                              </ListItem>
                              <ListItem>
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontSize: 15,
                                    fontWeight: "medium",
                                    lineHeight: "20px",
                                    mb: "2px",
                                  }}
                                >
                                  Platform:{" "}
                                  {this.props.auth.otherLoggedInUser.device
                                    .platform
                                    ? this.props.auth.otherLoggedInUser.device
                                        .platform
                                    : "Unknown"}
                                </ListItemText>
                              </ListItem>
                              <ListItem>
                                <ListItemText
                                  primaryTypographyProps={{
                                    fontSize: 15,
                                    fontWeight: "medium",
                                    lineHeight: "20px",
                                    mb: "2px",
                                  }}
                                >
                                  Time:{" "}
                                  {this.props.auth.otherLoggedInUser.time &&
                                  this.props.auth.otherLoggedInUser.time_diff
                                    ? `${this.props.auth.otherLoggedInUser.time_diff} (${this.props.auth.otherLoggedInUser.time})`
                                    : "Unknown"}
                                </ListItemText>
                              </ListItem>
                            </List>
                          )
                        ) : (
                          <List dense>
                            <ListItem>
                              <ListItemText
                                primaryTypographyProps={{
                                  fontSize: 15,
                                  fontWeight: "medium",
                                  lineHeight: "20px",
                                  mb: "2px",
                                }}
                              >
                                Browser: Unknown
                              </ListItemText>
                            </ListItem>
                            <ListItem>
                              <ListItemText
                                primaryTypographyProps={{
                                  fontSize: 15,
                                  fontWeight: "medium",
                                  lineHeight: "20px",
                                  mb: "2px",
                                }}
                              >
                                Platform: Unknown
                              </ListItemText>
                            </ListItem>
                            <ListItem>
                              <ListItemText
                                primaryTypographyProps={{
                                  fontSize: 15,
                                  fontWeight: "medium",
                                  lineHeight: "20px",
                                  mb: "2px",
                                }}
                              >
                                Time: Unknown
                              </ListItemText>
                            </ListItem>
                          </List>
                        )}
                        <Typography
                          sx={{ fontFamily: "inherit" }}
                          variant="body1"
                        >
                          If you do not recognise this device, You can logout
                          all devices by clicking on the{" "}
                          <span style={{ color: "red" }}>
                            <strong>"Log Out All Devices"</strong>
                          </span>{" "}
                          button
                        </Typography>
                        <Typography
                          sx={{ fontFamily: "inherit" }}
                          variant="body1"
                        >
                          If you recognise this device, You can keep all devices
                          logged in by clicking{" "}
                          <span style={{ color: "green" }}>
                            <strong>"Keep Devices Logged In"</strong>
                          </span>{" "}
                          button
                        </Typography>

                        <Stack direction="row" spacing={5}>
                          <Button
                            variant="outlined"
                            color="success"
                            onClick={() => {
                              axios
                                .post("/auth/device", {
                                  logout: false,
                                  userName: this.props.auth.loginName,
                                })
                                .then((res) => {
                                  this.props.setTokenIsValid();
                                  onClose();
                                })
                                .catch((err) => console.log(""));
                            }}
                          >
                            Keep Devices Logged In
                          </Button>
                          <Button
                            variant="contained"
                            color="error"
                            onClick={() => {
                              axios
                                .post("/auth/device", {
                                  logout: true,
                                  userName: this.props.auth.userName,
                                })
                                .then((res) => {
                                  onClose();
                                  if (res)
                                    window.$("#tokenExpiryModal").modal("show");
                                })
                                .catch((err) => console.error(""));
                            }}
                          >
                            Logout All Devices
                          </Button>
                        </Stack>
                      </Stack>
                    </Paper>
                  );
                },
                closeOnEscape: false,
                closeOnClickOutside: false,
                overlayClassName: "react-confirm-alert-custom-overlay",
              });
            } else if (
              error.response.status === 403 &&
              error.response.data.message.includes("You seem to be logged out")
            ) {
              // this.props.setTokenIsInValid();
              window.location.assign(
                process.env.REACT_APP_HOMEPAGE
              );
            } else if (
              error.response.status === 403 &&
              error.response.data.message.includes("access token") &&
              this.props.auth.tokenIsValid
            ) {
              this.props.setTokenIsInValid();
              window.$("#tokenExpiryModal").modal("show");
            } else if (
              error.response.status === 400 &&
              error.response.data.message.includes("Access token") &&
              this.props.auth.tokenIsValid
            ) {
              this.props.setTokenIsInValid();
              window.$("#tokenExpiryModal").modal("show");
            }
            if (
              error.response.status === 406 &&
              error.response.data.message.includes("time zone")
            )
              window.$("#timezoneModal").modal("show");

            if (
              error.response.status === 403 &&
              error.response.data.message === "Account is blocked"
            )
              this.props.onSetUserBlocked();
          } else if (error.request) {
            message =
              "A request made to the server did not succeed. This usually happens either because of a random system feature - in which case you should contact Software Technologies Limited for assistance, or poor internet connectivity - in which case you should liaise with your technical department.";
            errorType = "warning";
            this.setState({ mannualDismissal: true });
            console.error(error.request);
          } else {
            message =
              "An application error occured. This was not caused by you. Contact Sofware Technologies Limited for assistance.";
            errorType = "error";
            this.setState({ mannualDismissal: true });
            console.error(error.message);
          }

          this.setState({ error: message, type: errorType });
          if (this.props.isUpdated) this.props.onLoaded();
        }
      );
    }

    componentWillUnmount() {
      axios.interceptors.request.eject(this.requestInterceptor);
      axios.interceptors.response.eject(this.responseInterceptor);
    }

    componentDidUpdate() {
      return (
        this.state.error &&
        this.setState({ error: null, type: null, mannualDismissal: false })
      );
    }

    render() {
      return (
        <Fragment>
          {this.state.error && (
            <Notification
              type={this.state.type}
              message={this.state.error}
              mannualDismissal={this.state.mannualDismissal}
              title="Alert"
            />
          )}
          <WrappedComponent {...this.props} />
        </Fragment>
      );
    }
  };
};

const mapStateToProps = (state) => {
  return {
    loading: state.utilities.loading,
    auth: state.auth.authData,
    isUpdated: state.groups.isUpdated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoading: () => dispatch({ type: "SET_LOADING" }),
    onLoaded: () => dispatch({ type: "REMOVE_LOADING" }),
    onSetUserBlocked: () => dispatch({ type: "SET_USER_BLOCKED" }),
    setOtherLoggedInUser: (otherLoggedInUser) =>
      dispatch({ type: "OTHER_LOGGED_IN_USER", payload: otherLoggedInUser }),
    setTokenIsValid: () => dispatch({ type: "SET_TOKEN_VALIDITY" }),
    setTokenIsInValid: () => dispatch({ type: "SET_TOKEN_INVALID" }),
    resetGroups: () => dispatch({ type: "RESET_GROUPS" }),
    resetUsers: () => dispatch({ type: "RESET_USERS" }),
    resetNonUsers: () => dispatch({ type: "RESET_NONUSERS" }),
    resetResources: () => dispatch({ type: "RESET_RESOURCES" }),
    resetApprovals: () => dispatch({ type: "RESET_APPROVALS" }),
    signOut: () => dispatch({ type: "SIGN_OUT" }),
  };
};

errorHandler.propTypes = {
  onLoading: propTypes.func,
  onLoaded: propTypes.func,
  onSetUserBlocked: propTypes.func,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  errorHandler
);
